import axios from 'axios'
import pLimit from 'p-limit'
import { getVideoUploadUrls, completeVideoUpload } from './api'

let PART_SIZE = 5242880 // 5MB — matches multipart threshold

export let uploadVideoToS3 = async (
  file: File,
  onProgress: (pct: number) => void,
): Promise<string> => {
  let numberOfParts = Math.floor(file.size / PART_SIZE) || 1
  let { signedURLs, uploadID, key } = await getVideoUploadUrls(numberOfParts)

  let partSize = Math.ceil(file.size / numberOfParts)
  let limit = pLimit(6)
  let completedParts = 0

  let partResults = await Promise.all(
    signedURLs.map((url, i) =>
      limit(async () => {
        let part = file.slice(i * partSize, (i + 1) * partSize)
        let response = await axios.put(url, part, {
          headers: { 'content-type': 'video/mp4' },
        })
        // eslint-disable-next-line fp/no-mutation
        completedParts += 1
        onProgress(Math.round((completedParts / numberOfParts) * 90))
        return { etag: response.headers.etag as string, partNumber: i + 1 }
      }),
    ),
  )

  await completeVideoUpload({ key, uploadID, parts: partResults })
  onProgress(100)
  return key
}
